/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { SalesContactSimilarEmailOtherCompany } from "./SalesContactSimilarEmailOtherCompany";
import {
  SalesContactSimilarEmailOtherCompanyFromJSON,
  SalesContactSimilarEmailOtherCompanyFromJSONTyped,
  SalesContactSimilarEmailOtherCompanyToJSON,
  SalesContactSimilarEmailOtherCompanyToJSONTyped,
} from "./SalesContactSimilarEmailOtherCompany";

/**
 *
 * @export
 * @interface SalesContactSimilarEmailElsewhere
 */
export interface SalesContactSimilarEmailElsewhere {
  /**
   *
   * @type {string}
   * @memberof SalesContactSimilarEmailElsewhere
   */
  salesContactId: string;
  /**
   *
   * @type {string}
   * @memberof SalesContactSimilarEmailElsewhere
   */
  email: string;
  /**
   *
   * @type {Array<SalesContactSimilarEmailOtherCompany>}
   * @memberof SalesContactSimilarEmailElsewhere
   */
  otherCompanies: Array<SalesContactSimilarEmailOtherCompany>;
}

/**
 * Check if a given object implements the SalesContactSimilarEmailElsewhere interface.
 */
export function instanceOfSalesContactSimilarEmailElsewhere(
  value: object,
): value is SalesContactSimilarEmailElsewhere {
  if (!("salesContactId" in value) || value["salesContactId"] === undefined)
    return false;
  if (!("email" in value) || value["email"] === undefined) return false;
  if (!("otherCompanies" in value) || value["otherCompanies"] === undefined)
    return false;
  return true;
}

export function SalesContactSimilarEmailElsewhereFromJSON(
  json: any,
): SalesContactSimilarEmailElsewhere {
  return SalesContactSimilarEmailElsewhereFromJSONTyped(json, false);
}

export function SalesContactSimilarEmailElsewhereFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SalesContactSimilarEmailElsewhere {
  if (json == null) {
    return json;
  }
  return {
    salesContactId: json["salesContactId"],
    email: json["email"],
    otherCompanies: (json["otherCompanies"] as Array<any>).map(
      SalesContactSimilarEmailOtherCompanyFromJSON,
    ),
  };
}

export function SalesContactSimilarEmailElsewhereToJSON(
  json: any,
): SalesContactSimilarEmailElsewhere {
  return SalesContactSimilarEmailElsewhereToJSONTyped(json, false);
}

export function SalesContactSimilarEmailElsewhereToJSONTyped(
  value?: SalesContactSimilarEmailElsewhere | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    salesContactId: value["salesContactId"],
    email: value["email"],
    otherCompanies: (value["otherCompanies"] as Array<any>).map(
      SalesContactSimilarEmailOtherCompanyToJSON,
    ),
  };
}
